import React from 'react';
import SavedPaymentMethodCard from './SavedPaymentMethodCard';
import SavedPaymentMethodBank from './SavedPaymentMethodBank';
import {
  isCardPaymentMethod,
  isUsBankAccountPaymentMethod,
} from './stripe.types';
import { FragmentOf } from 'gql.tada';
import { STRIPE_PAYMENT_METHOD } from 'modes/company/pages/profile/CompanyProfile.query';

type Props = {
  method?: FragmentOf<typeof STRIPE_PAYMENT_METHOD>;
};

export default function SavedPaymentMethod({ method }: Props) {
  if (!method) {
    return (
      <div style={{ padding: '1rem', color: '#555' }}>
        No payment method on file.
      </div>
    );
  }

  if (isCardPaymentMethod(method)) {
    return <SavedPaymentMethodCard method={method} />;
  }

  if (isUsBankAccountPaymentMethod(method)) {
    return <SavedPaymentMethodBank method={method} />;
  }

  return (
    <div style={{ padding: '1rem', color: '#555' }}>
      Unsupported payment method type: {(method as any).type}
    </div>
  );
}
